import { Component, computed, inject, OnInit, signal } from "@angular/core";
import { SpinnerComponent } from "../spinner/spinner.component";
import { ParameterService, PaymentService } from "../../provider";
import { AmazonpayAutorizeCapture } from "../amazonpay-autorize-capture/amazonpay-autorize-capture";
import { AmazonpayCheckout } from "../amazonpay-checkout/amazonpay-checkout";

@Component({
    selector: 'lib-frontend-amazonpay',
    styleUrl: './amazonpay.css',
    templateUrl: './amazonpay.html',
    standalone: true,
    imports: [
        AmazonpayAutorizeCapture,
        AmazonpayCheckout
    ]
})
export class Amazonpay
{

    public parameterService = inject(ParameterService);

}